module.exports = __webpack_public_path__ + "static/media/el.2d33e19f.jpg";